<template>
    <v-container fluid grid-list-lg>
        <v-layout row wrap>
            <template v-for="tribune in tribunes">
                <v-flex v-bind:key="tribune['.key']" xs6>
                    <v-card class="white--text" v-bind:color="tribune['.key'] == selectedTribuneKey ? 'blue-grey darken-4' : 'blue-grey darken-1'">
                        <v-card-title primary-title>
                            <div>
                                <h3 class="headline mb-0">{{ tribune.description }} (Blok {{ tribune.block }})</h3>
                                <div>{{tribune.places}} plaatsen</div>
                            </div>
                        </v-card-title>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn flat dark @click="() => { selectTribune(tribune, 'gratis') }">Select (gratis)</v-btn>
                            <v-btn flat dark @click="() => { selectTribune(tribune, tribune.price_subscription) }">Select (&euro; {{tribune.price_subscription}})</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </template>
        </v-layout>
    </v-container>
</template>

<script>
import { db } from "../../firebase";

export default {
  name: "Tribunes",
  props: {
    msg: String,
    selectedTribuneKey: String,
    selectedTribunePrice: String | Number
  },
  data() {
    return {
      tribunes: []
    };
  },
  firestore() {
    return {
      tribunes: db.collection("tribunes").orderBy("description")
    };
  },
  methods: {
    selectTribune: function(tribune, price) {
      this.$emit("tribuneSelected", tribune, price);
    }
  }
};
</script>
